import { applyMiddleware, createStore, compose, combineReducers } from "redux";
import logger from "redux-logger";
import thunk from "redux-thunk";
import promise from "redux-promise-middleware";
import blockui from "react-block-ui/lib/reduxMiddleware";
import { reducer as notifications } from "react-notification-system-redux";

import  { getNavReducers, getMiddleware } from "@fpos/react-navigation";

import { testStoreName } from "./main/mainActions.js";
import testStore from "./main/mainReducer.js";
import { settingsPromise } from "../utils/settings";


export default async function configureStore(initialState)
{
    const settings = await settingsPromise;

    let middlewares = [promise(), thunk, blockui, ...getMiddleware(settings.oauthConfig)];
    if (settings.includeReduxLogger && settings.includeReduxLogger === "true") {
        middlewares.push(logger);
    }

    const middleware = applyMiddleware.apply(null, middlewares);
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

    const reduc = {
        notifications: notifications,
        ...getNavReducers()
    };
    reduc[testStoreName] = testStore;
    console.log(initialState);

    const store = createStore(
        combineReducers(reduc),
        initialState,
        composeEnhancers(middleware)
    );
    console.log(store.getState());
    return store;
}